"use client";

import Image from "next/image";
import React, { useEffect, useState, useRef, memo } from "react";

interface ProjectSliderProps {
  images: string[];
  isActive: boolean;
}

function ProjectSlider({ images, isActive }: ProjectSliderProps) {
  const [index, setIndex] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isActive) {
      timerRef.current = setInterval(() => {
        setIndex((prev) => (prev + 1) % images.length);
      }, 3000);
    }
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isActive, images.length]);

  return (
    <div className="relative w-full h-full overflow-hidden rounded-2xl will-change-transform">
      {images.map((img, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-1000 ease-in-out"
          style={{ opacity: i === index ? 1 : 0 }}
        >
          <Image
            src={img}
            alt={`Project Image ${i + 1}`}
            fill
            loading={i === 0 ? "eager" : "lazy"}
            className="object-cover"
            // 1×1 dark gray inline data URL — replaces the missing
            // `/blur-placeholder.png` that was 404-ing in dev. Keeps the
            // blur-up effect on slow connections without a network round-trip.
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAALEAvbjLqnkAAAAASUVORK5CYII="
            sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw"
          />
        </div>
      ))}
    </div>
  );
}

export default memo(ProjectSlider);
